import React from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Text from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import { Info } from '@dbk/ui-icons'
import InfoBox from '@dbk/com.db.dbk.ui-info-box'
import { ROUTES } from '../../../constants';
import '../../../assets/styles/beneficiary-address-banner.scss';
import { beneficiaryAddressSplitTitleAndBody } from '../text/utils';


class BeneficiaryAddressBanner extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  onInfoClose = () => {
    const { changePage } = this.props;
    this.props.banner.setShowBeneficiaryBanner(false);
  }

  onUpdateClick = () => {
    this.props.payments.setIsBeneficiaryBannerFlow(true);
    this.props.changePage(ROUTES.PAYMENT.DESTINATION);
    this.props.payments.setDisableTabs(true);
  }

  // API sends the whole banner text as one string, e.g. "Regulatory Changes: ...".
  // Use shared helper to split the leading label (title) from the body.
  renderMessage = (content) => {
    const { title, body } = beneficiaryAddressSplitTitleAndBody(content);
    if (!title) return content;
    return (
      <>
        <strong className="beneficiary-banner__message-title">{title}</strong>
        {body}
      </>
    );
  }

  render() {
    const { banner: { showBeneficiaryBanner, beneficiaryBannerData }, i18n: { messages }, app: { config: { enableStructuredAddress } = {} } = {} } = this.props;

    if (!enableStructuredAddress) {
      return null;
    }

    if (!showBeneficiaryBanner || !beneficiaryBannerData) {
      return null;
    }

    const displayContent = beneficiaryBannerData?.alertItems?.[0]?.content;
    if (!displayContent) {
      return null;
    }
    return displayContent && (
      <div className="beneficiary-banner__wrapper">
        <InfoBox
          information
          fullWidth
          renderMain={() => (
            <div className="beneficiary-banner__main">
              <span className="beneficiary-banner__message">
                {this.renderMessage(displayContent)}
              </span>
              <div className="button__update-beneficiary-address">
                <Button
                  size="medium"
                  onPress={this.onUpdateClick}
                  testID="btn_update-beneficiary-address">
                  {messages['app.beneficiary.address.updateButton']}
                </Button>
              </div>
            </div>
          )}
        />
      </div>
    )
    
  }
}

export default createContainer({
  $queries: {
    i18n:{
      messages: true
    },
    payments: {
      setIsBeneficiaryBannerFlow: { $set: 'isBeneficiaryBannerFlow' },
      setDisableTabs: { $set: 'disableTabs' },
    },
    app: {
      config: {
        enableStructuredAddress: true,
      },
    },
    banner: {
      showBeneficiaryBanner: true,
      beneficiaryBannerData: true,
      setShowBeneficiaryBanner: { $set: 'showBeneficiaryBanner' }
    },
    changePage: { $call: 'ui.history.push' }
  },
})(BeneficiaryAddressBanner);
